import type { FeatureFlagsConfig } from "@climatepartner/app-shell/feature-flags";

import { featureToggleKeys } from "./feature-toggles";

/** AppShell loads these from ConfigCat (`config.featureFlags`) and targets the user by email. */
export const featureFlagsConfig: FeatureFlagsConfig = {
  sdkKey: import.meta.env.VITE_CONFIG_CAT_PUBLIC_KEY,
  keys: featureToggleKeys,
};
